import { nextTick, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { axiosCustom } from '@/plugins/axios'
import { tokenService } from '@/services/token'

let widgetScript = null
let isWidgetLoaded = false

const fetchScrmToken = async () => {
  const cached = tokenService.getScrmToken()
  if (cached) return cached

  try {
    const { data } = await axiosCustom.get('/v3/users/scrm-token')
    if (data.access_token) {
      tokenService.saveScrmToken(data.access_token, data.expires_in || 3600)
      return data.access_token
    }
    return null
  } catch {
    return null
  }
}

export function useWidget() {
  const route = useRoute()

  const connectWidget = async (projectId = null) => {
    if (widgetScript && document.body.contains(widgetScript)) {
      return
    }

    window.SCRMprojectID = projectId
    window.SCRMuserToken = await fetchScrmToken()

    widgetScript = document.createElement('script')
    widgetScript.src = `${process.env.VUE_APP_WIDGET_SCRM_SRC}?time=${new Date().getTime()}`
    widgetScript.async = true

    widgetScript.onload = () => {
      isWidgetLoaded = true
      if (window.wrgsv && typeof window.wrgsv.init === 'function') {
        window.wrgsv.init()
      }
    }

    document.body?.appendChild(widgetScript)
  }

  const updateWidgetProjectId = (projectId) => {
    if (window.SCRMprojectID !== projectId) {
      window.SCRMprojectID = projectId
      if (isWidgetLoaded && window.wrgsv && typeof window.wrgsv.init === 'function') {
        window.wrgsv.init()
      }
    }
  }

  onMounted(() => {
    const isProjectPage = route.name === 'project-by-id'
    const projectId = isProjectPage ? route.params?.id : null
    nextTick(() => {
      connectWidget(projectId)
    })
  })

  watch(
    () => route.name,
    (newRouteName) => {
      const isProjectPage = newRouteName === 'project-by-id'
      const projectId = isProjectPage ? route.params?.id : null
      updateWidgetProjectId(projectId)
    },
  )

  watch(
    () => route.params?.id,
    (newId) => {
      if (route.name === 'project-by-id') {
        updateWidgetProjectId(newId)
      } else {
        updateWidgetProjectId(null)
      }
    },
  )

  return {
    connectWidget,
    updateWidgetProjectId,
  }
}
